import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=7047b5a2&scoped=true"
import script from "./Title.ts?vue&type=script&lang=ts&external"
export * from "./Title.ts?vue&type=script&lang=ts&external"
import style0 from "./Title.vue?vue&type=style&index=0&id=7047b5a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7047b5a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7047b5a2')) {
      api.createRecord('7047b5a2', component.options)
    } else {
      api.reload('7047b5a2', component.options)
    }
    module.hot.accept("./Title.vue?vue&type=template&id=7047b5a2&scoped=true", function () {
      api.rerender('7047b5a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Core/components/Title/Title.vue"
export default component.exports